(() => {
  "use strict";

  const CARD_SELECTOR = ".product-card";

  const PARTS = [
    ".product-card__heading",
    '[id^="price-"]',
    ".product-card__variants, card-variant-selects"
  ];

  function resetHeights(cards) {
    cards.forEach(card => {
      PARTS.forEach(selector => {
        const el = card.querySelector(selector);
        if (el) el.style.minHeight = "";
      });
    });
  }

  function groupRows(cards) {
    const rows = [];
    let row = [];
    let lastTop = null;

    cards.forEach(card => {
      const top = Math.round(card.getBoundingClientRect().top);

      if (lastTop === null) {
        lastTop = top;
      }

      if (Math.abs(top - lastTop) > 5) {
        rows.push(row);
        row = [];
        lastTop = top;
      }

      row.push(card);
    });

    if (row.length) rows.push(row);

    return rows;
  }

  function equalizeRow(row) {

    PARTS.forEach(selector => {

      let max = 0;
      const els = [];

      row.forEach(card => {
        const el = card.querySelector(selector);

        if (!el) return;

        el.style.minHeight = "";

        max = Math.max(max, el.offsetHeight);

        els.push(el);
      });

      els.forEach(el => {
        el.style.minHeight = max + "px";
      });

    });

  }

  function equalize() {

    const cards = [...document.querySelectorAll(CARD_SELECTOR)];

    if (!cards.length) return;

    resetHeights(cards);

    requestAnimationFrame(() => {

      const rows = groupRows(cards);

      rows.forEach(equalizeRow);

    });

  }

  let resizeTimer;

  function refresh() {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(equalize, 60);

  }

  window.addEventListener("load", refresh);

  window.addEventListener("resize", refresh);

  document.addEventListener("DOMContentLoaded", refresh);

  const observer = new MutationObserver(refresh);

  window.addEventListener("load", () => {

    const grid =
      document.querySelector("#ProductGridContainer") ||
      document.querySelector(".collection__container") ||
      document.body;

    observer.observe(grid, {
      childList: true,
      subtree: true
    });

  });

})();